import { render, staticRenderFns } from "./dcRecord.vue?vue&type=template&id=84b9d5a6&scoped=true&"
import script from "./dcRecord.vue?vue&type=script&lang=js&"
export * from "./dcRecord.vue?vue&type=script&lang=js&"
import style0 from "./dcRecord.vue?vue&type=style&index=0&id=84b9d5a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b9d5a6",
  null
  
)

export default component.exports